import React from 'react'

import { IconSizes, Spacings } from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const IconStyle: React.CSSProperties = {
  flexShrink: 0,
  marginLeft: toPx(Spacings.BLOCK_VERTICAL_SPACING),
  width: toPx(IconSizes.MEDIUM),
  height: toPx(IconSizes.MEDIUM),
  marginTop: toPx(Spacings.EXTRA_EXTRA_SMALL),
}

export const WrapperStyle: React.CSSProperties = {
  position: 'relative',
  display: 'flex',
  borderRadius: '30px 30px 0 0',
  padding: '12px 0 10px 0',
}

export const TitleStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  marginRight: '32px',
  justifyContent: 'center',
}
